import { useContext } from 'react';

import {
  type RectDataInternal,
  XYChartRectDataContext,
} from '../context/XYChartRectData.context.js';

export const useRectData = () => {
  const context = useContext(XYChartRectDataContext);

  if (context === undefined) {
    throw new Error('useRectData must be used within a XYChartRectDataContext');
  }

  return context as Required<RectDataInternal>;
};
